<template>
  <td class="text-center">
    <button
      @click="calculate()"
      v-if="!data && !calculating"
      class="btn btn-secondary"
      type="button"
    >
      <i class="fas fa-calculator"></i>
    </button>
    <i v-if="calculating" class="fas fa-sync fa-2x fa-spin spinner"></i>
    <div v-if="data && !calculating">
      {{ data }}
      <i
        @click="calculate()"
        style="cursor: pointer;"
        class="fas fa-sync"
        aria-hidden="true"
      ></i>
    </div>
  </td>
</template>

<script>
export default {
  props: ["model", "attribute"],
  data() {
    return {
      calculating: false,
      data: ""
    };
  },
  methods: {
    calculate() {
      this.calculating = true;
      this.$http
        .get(`/api/v1/customerProfile/${this.model.id}/in-out-count`)
        .then(response => {
          this.data = response.data;
        })
        .finally(() => {
          this.calculating = false;
        });
    }
  }
};
</script>
